"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBoxV2 = exports.FIELD_TYPE = exports.DATA_TYPES = void 0;
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const separator_builder_1 = require("@app/util/builders/separator-builder");
const format_hours_1 = require("@app/util/format-hours");
const icon_1 = require("../icon");
const separator_1 = require("../separator");
const spacing_1 = require("../spacing");
const tooltip_1 = require("../tooltip");
require("./info-box-v2.scss");
const ProgressCircle_1 = require("./ProgressCircle");
var SIZES;
(function (SIZES) {
    SIZES["SMALL"] = "small";
    SIZES["LARGE"] = "large";
})(SIZES || (SIZES = {}));
var DATA_TYPES;
(function (DATA_TYPES) {
    DATA_TYPES["CURRENCY"] = "currency";
    DATA_TYPES["HOURS"] = "hours";
    DATA_TYPES["NUMBER"] = "number";
    DATA_TYPES["TEXT"] = "text";
})(DATA_TYPES || (exports.DATA_TYPES = DATA_TYPES = {}));
var FIELD_TYPE;
(function (FIELD_TYPE) {
    FIELD_TYPE["DATA"] = "data";
    FIELD_TYPE["DIFFERENCE"] = "difference";
    FIELD_TYPE["BUTTON"] = "button";
})(FIELD_TYPE || (exports.FIELD_TYPE = FIELD_TYPE = {}));
const Data = ({ dataType = DATA_TYPES.NUMBER, fieldType = FIELD_TYPE.DATA, unitInLabel = false, value = 0, sign = '', label, helpText, currency, onClick, overColor, underColor, iconProps, valueColor, }) => {
    const createUnitInLabel = () => {
        switch (dataType) {
            case DATA_TYPES.CURRENCY: {
                const currencySymbol = util_1.numberUtil.getCurrencySymbol({ currency });
                return `(${currencySymbol?.toUpperCase()})`;
            }
            case DATA_TYPES.HOURS:
                return `(${(0, util_1.t)('HOUR_SHORT')?.toUpperCase()})`;
            case DATA_TYPES.NUMBER:
                return '';
            default:
                return '';
        }
    };
    const createValue = (v) => {
        if ((0, util_1.isUndefined)(v) || (0, util_1.isNull)(v) || Number.isNaN(v))
            return '-';
        const _value = Math.round(v * 100) / 100;
        if (unitInLabel)
            return util_1.numberUtil.localizeNumber(_value);
        switch (dataType) {
            case DATA_TYPES.CURRENCY:
                return util_1.numberUtil.localizeAsCurrency(_value);
            case DATA_TYPES.HOURS:
                return (0, format_hours_1.formatHours)(_value);
            case DATA_TYPES.NUMBER:
            default:
                return util_1.numberUtil.localizeNumber(_value);
        }
    };
    if (fieldType === FIELD_TYPE.BUTTON) {
        return (react_1.default.createElement("div", { className: 'data-container' },
            label && (react_1.default.createElement("div", { className: 'info-box-label' },
                react_1.default.createElement("a", { style: { color: '#0045ff' }, type: 'button', onClick: onClick },
                    label.toUpperCase(),
                    unitInLabel ? ` ${createUnitInLabel()}` : ''),
                helpText && (react_1.default.createElement("div", { className: 'ml-4' },
                    react_1.default.createElement(tooltip_1.HelpTooltip, { text: helpText }))))),
            react_1.default.createElement("span", { className: 'value' },
                react_1.default.createElement(icon_1.Icon, { size: 'small', color: 'primary', ico: 'arrow-right', onClick: onClick }))));
    }
    if (fieldType === FIELD_TYPE.DIFFERENCE) {
        if (typeof value !== 'number')
            throw new Error('value must be a number');
        const moreThanPlanned = value > 0;
        const lessThanPlanned = value < 0;
        const asPlanned = value === 0;
        const color = moreThanPlanned
            ? overColor
            : lessThanPlanned
                ? underColor
                : undefined;
        return (react_1.default.createElement("div", { className: 'data-container' },
            label && (react_1.default.createElement("div", { className: 'info-box-label' },
                label.toUpperCase(),
                unitInLabel ? ` ${createUnitInLabel()}` : '',
                helpText && (react_1.default.createElement("div", { className: 'ml-4' },
                    react_1.default.createElement(tooltip_1.HelpTooltip, { text: helpText }))))),
            react_1.default.createElement("span", { className: 'value field-difference', style: { color } },
                moreThanPlanned && react_1.default.createElement("span", { className: 'arrow-up' }, "\u25B2"),
                lessThanPlanned && react_1.default.createElement("span", { className: 'arrow-down' }, "\u25BC"),
                asPlanned && react_1.default.createElement("span", { className: 'no-arrow' }),
                typeof value === 'number' ? createValue(Math.abs(value)) : value)));
    }
    return (react_1.default.createElement("div", { className: 'data-container', onClick: onClick || undefined, style: {
            cursor: onClick ? 'pointer' : undefined,
        } },
        label && (react_1.default.createElement("div", { className: 'info-box-label-container' },
            iconProps ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(icon_1.Icon, { color: iconProps.color, ico: iconProps.name, size: 'medium' }),
                react_1.default.createElement(spacing_1.Spacing, { type: spacing_1.Spacing.TYPES.HORIZONTAL, size: spacing_1.Spacing.SIZES.SIZE_4 }))) : (false),
            react_1.default.createElement("div", { className: 'info-box-label' },
                label.toUpperCase(),
                unitInLabel ? ` ${createUnitInLabel()}` : ''),
            helpText && (react_1.default.createElement("div", { className: 'ml-4' },
                react_1.default.createElement(tooltip_1.HelpTooltip, { text: helpText }))),
            onClick ? (react_1.default.createElement("div", { className: 'ml-4' },
                react_1.default.createElement(icon_1.Icon, { color: 'dark-blue', ico: 'arrow-right', size: 'small' }))) : (false))),
        react_1.default.createElement("span", { className: 'value', style: { color: valueColor } },
            sign,
            typeof value === 'number' ? createValue(value) : value)));
};
const INFOBOX_BASE_WIDTH = 10.125;
const InfoBoxV2 = ({ title, helpText, header, cols, progress, colorfulProgress, showEmptyProgress, grow, shrink, basis, size, }) => {
    const hasProgress = (0, util_1.isDefined)(progress) && !isNaN(progress);
    return (react_1.default.createElement("div", { className: 'ds-info-box-v2' + (cols.length === 0 ? ' infobox-small' : ''), style: {
            minWidth: size === 'full-width' ? '100%' : `${INFOBOX_BASE_WIDTH * cols.length}rem`,
            flexGrow: grow,
            flexShrink: shrink,
            flexBasis: basis ? `${basis}%` : undefined,
        } },
        header || title || helpText || progress || showEmptyProgress ? (react_1.default.createElement("div", { className: 'top' },
            react_1.default.createElement("div", { className: 'title' }, (0, util_1.isDefined)(header) ? (header) : (react_1.default.createElement(react_1.default.Fragment, null,
                title?.toUpperCase(),
                helpText && (react_1.default.createElement("div", { className: 'ml-4' },
                    react_1.default.createElement(tooltip_1.HelpTooltip, { text: helpText })))))),
            hasProgress ? (react_1.default.createElement(ProgressCircle_1.ProgressCircle, { progress: Math.floor(progress), size: cols.length <= 1 ? SIZES.SMALL : SIZES.LARGE, colorfulProgress: colorfulProgress })) : showEmptyProgress ? (react_1.default.createElement(ProgressCircle_1.ProgressCircle, { size: cols.length <= 1 ? SIZES.SMALL : SIZES.LARGE, colorfulProgress: colorfulProgress })) : null)) : (false),
        cols.length > 0 && (react_1.default.createElement("div", { className: 'columns' },
            react_1.default.createElement(separator_builder_1.SeparatorBuilder, { elements: cols, separator: react_1.default.createElement("div", { className: 'separator' },
                    react_1.default.createElement(separator_1.Separator, { side: separator_1.Separator.SIDES.LEFT, size: separator_1.Separator.SIZES.FULL_HEIGHT })), getKey: (col, index) => col.data.map((d) => d.label).join() + '_' + index.toString() }, (el) => (react_1.default.createElement("div", { className: 'col', style: { justifyContent: el.direction ?? 'end' } }, el.data.map((d, index) => (react_1.default.createElement("div", { key: index, style: {
                    marginTop: index > 0 ? '3px' : 0,
                } },
                react_1.default.createElement(Data, { ...d })))))))))));
};
exports.InfoBoxV2 = InfoBoxV2;
exports.InfoBoxV2.DATA_TYPES = DATA_TYPES;
exports.InfoBoxV2.FIELD_TYPES = FIELD_TYPE;
exports.InfoBoxV2.EMPTY_LINE = {
    label: '\u00A0',
    value: '\u00A0',
    dataType: exports.InfoBoxV2.DATA_TYPES.TEXT,
};
